import {useEffect} from 'react';

import {GridApi} from '../types/AgGridTypes';
import {FeGridSettings} from '../types/Api';
import {LineHeightMappingToPx} from '../utils/lineHeightToPx';

export const useHeaderHeight = (settings: FeGridSettings, gridApi?: GridApi) =>
  useEffect(() => {
    if (gridApi && !gridApi.isDestroyed()) {
      if (settings.columnGroupsVisible) {
        gridApi.setGridOption('groupHeaderHeight', LineHeightMappingToPx[settings.headerHeight]);
      } else {
        // first we have to set height to zero to hide content then to -1 to hide border, reasons can be found in ag-grid source code
        gridApi.setGridOption('groupHeaderHeight', 0);
        gridApi.setGridOption('groupHeaderHeight', -1);
      }
      gridApi.setGridOption('headerHeight', LineHeightMappingToPx[settings.headerHeight]);

      // Wrap refreshHeader in a try-catch to prevent errors when column groups are not yet initialized
      // AG Grid may call getProvidedColumnGroup() on null columns during internal processing
      try {
        gridApi.refreshHeader();
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          console.warn('refreshHeader failed - column groups may not be initialized yet:', error);
        }
      }
    }
  }, [gridApi, settings.columnGroupsVisible, settings.headerHeight]);
